/** Chart colours and sizes. The dashboard's own; not @zealth/core/charts. */
export const chartTheme = {
  fontSize: 11,
  axis: {
    labelColor: '#94a3b8', // slate-400
    lineColor: 'rgba(148, 163, 184, 0.25)',
    splitLineColor: 'rgba(148, 163, 184, 0.12)',
  },
  legend: { textColor: '#64748b' }, // slate-500
  tooltip: {
    backgroundColor: 'rgba(15, 23, 42, 0.92)', // slate-950
    textColor: '#f1f5f9', // slate-100
  },
  series: ['#047857', '#0ea5e9', '#f59e0b'], // brand-700, sky-500, amber-500
} as const

export const CHART_HEIGHT = { bars: 220, spark: 140 } as const
